import * as React from 'react';
import { Translate } from '../../../../shared/LanguageService';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import { IPhotographerInvoice } from '../photographer/SinglePhotographerInvoiceTypes';
import RejectedInvoiceListRow from './RejectedInvoiceListRow';
import ViewPhotographerInvoiceModal from '../photographer/ViewPhotographerInvoiceModal';
import ExcludedInvoiceListRow from './ExcludedInvoiceListRow';
import { Outlier } from './outliers/OutlierRow';
import { OutliersSection } from './outliers/OutliersSection';
import { CostCheck } from './outliers/CostCheck';

interface IProps {
    closeModal: () => void;
    html: string;
    allowSaving: boolean;
    save: () => void;
    working: boolean;
    outliers?: Outlier[];
    topTenCosts?: CostCheck[];

    rejections: IPhotographerInvoice[];
    exclusions: IPhotographerInvoice[];
    passivePhotographers: string[];
    showInvoice: (invoice: IPhotographerInvoice) => void;
    showModal: boolean;
    rejectedHtml: string;
    closeRejectionModal: () => void;
    rejectedInvoiceWorking: boolean;
    rejectedInvoice: IPhotographerInvoice;
    rejectMessage: string;
    unlockRejectedInvoice: () => void;
    updateRejectedInvoice: (invoice: IPhotographerInvoice) => void;
}

const ViewPhotographersInvoiceModal = (props: IProps) => {
    return (
        <Modal show={true} onHide={props.closeModal} bsSize="large">
            <Modal.Header closeButton>
                <Modal.Title>
                    {Translate('photographer-invoice-collections/modal/title')}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {(!props.rejections || props.rejections.length === 0) &&
                    (!props.passivePhotographers || props.passivePhotographers.length === 0) &&
                    (!props.exclusions || props.exclusions.length === 0) && (
                        <Row className="invoice-modal-row">
                            <Col xs={12} lg={12} className="invoice-preview-column">
                                {props.html && (
                                    <div
                                        id="invoice-preview"
                                        dangerouslySetInnerHTML={{
                                            __html: props.html
                                        }}
                                    ></div>
                                )}
                            </Col>
                        </Row>
                    )}
                {((props.rejections && props.rejections.length > 0) ||
                    (props.passivePhotographers && props.passivePhotographers.length > 0) ||
                    (props.exclusions && props.exclusions.length > 0)) && (
                    <Row className="invoice-modal-row">
                        <Col xs={9} lg={9} className="invoice-preview-column">
                            {props.html && (
                                <div
                                    id="invoice-preview"
                                    dangerouslySetInnerHTML={{
                                        __html: props.html
                                    }}
                                ></div>
                            )}
                        </Col>
                        <Col xs={3} lg={3}>
                            {props.topTenCosts ? <CostCheck costs={props.topTenCosts} /> : null}
                            {props.rejections && props.rejections.length > 0 && (
                                <div>
                                    <h2>
                                        {Translate(
                                            'photographer-invoice-collections/modal/rejections/title'
                                        )}
                                    </h2>
                                    {props.rejections.map(
                                        (x: IPhotographerInvoice, index: number) => (
                                            <RejectedInvoiceListRow
                                                key={index}
                                                invoice={x}
                                                view={(invoice: IPhotographerInvoice) =>
                                                    props.showInvoice(invoice)
                                                }
                                            />
                                        )
                                    )}
                                </div>
                            )}
                            {props.passivePhotographers && props.passivePhotographers.length > 0 && (
                                <div>
                                    <h2>
                                        {Translate(
                                            'photographer-invoice-collections/modal/passivePhotographers/title'
                                        )}
                                    </h2>
                                    {props.passivePhotographers.map(
                                        (name: string, index: number) => (
                                            <Row key={index}>
                                                <Col sm={12} md={6}>
                                                    <div>{name}</div>
                                                </Col>
                                            </Row>
                                        )
                                    )}
                                </div>
                            )}
                            {props.exclusions && props.exclusions.length > 0 && (
                                <div>
                                    <h2>
                                        {Translate(
                                            'photographer-invoice-collections/modal/exclusions/title'
                                        )}
                                    </h2>
                                    {props.exclusions.map(
                                        (x: IPhotographerInvoice, index: number) => (
                                            <ExcludedInvoiceListRow
                                                key={index}
                                                invoice={x}
                                                view={(invoice: IPhotographerInvoice) =>
                                                    props.showInvoice(invoice)
                                                }
                                            />
                                        )
                                    )}
                                </div>
                            )}
                            {props.outliers && props.outliers.length > 0 ? (
                                <OutliersSection outliers={props.outliers} />
                            ) : null}
                        </Col>
                    </Row>
                )}
            </Modal.Body>
            <Modal.Footer>
                {!props.working && (
                    <div>
                        <Button onClick={props.closeModal} bsStyle="default">
                            {Translate('photographer-invoice-collections/modal/close')}
                        </Button>
                        <Button onClick={() => window.print()} bsStyle="primary">
                            {Translate('photographer-invoice-collections/modal/print')}
                        </Button>
                        {props.allowSaving && (
                            <Button onClick={props.save} bsStyle="primary">
                                {Translate('photographer-invoice-collections/modal/save')}
                            </Button>
                        )}
                    </div>
                )}
                {props.working && <i className="load-spin-dark"></i>}
            </Modal.Footer>

            {props.showModal && (
                <ViewPhotographerInvoiceModal
                    html={props.rejectedHtml}
                    closeModal={props.closeRejectionModal}
                    allowSaving={true}
                    allowRejecting={false}
                    showRejectMessage={true}
                    working={props.rejectedInvoiceWorking}
                    invoice={props.rejectedInvoice}
                    rejectMessage={props.rejectMessage}
                    save={props.unlockRejectedInvoice}
                    update={(rejectedInvoice: IPhotographerInvoice) =>
                        props.updateRejectedInvoice(rejectedInvoice)
                    }
                    invoiceNumber={undefined}
                    onInvoiceNumberChange={undefined}
                    instructions={undefined}
                    onRejectMessageChange={undefined}
                    reject={undefined}
                    errors={undefined}
                />
            )}
        </Modal>
    );
};

export default ViewPhotographersInvoiceModal;
